export default {"src":"/_next/static/media/box.9d14dd1e.svg","height":24,"width":24};